import React from 'react';

interface InputProps {
  placeholder?: string;
}

const Input = ({ field, form, placeholder, className, ...props }: any) => {
  return (
    // <input
    //   {...field}
    //   {...props}
    //   className='block rounded-none border-b border-gray-100 dark:border-neutral-700 last:border-none p-2.5 w-full text-sm bg-transparent text-gray-900 dark:text-white  outline-none'
    // />
    <div className={`w-full pt-5 ${className}`}>
      <div className='relative w-full min-w-[200px] h-12'>
        <input
          {...field}
          {...props}
          className='peer w-full h-full bg-transparent text-white font-sans font-normal outline outline-0 focus:outline-0 disabled:bg-blue-gray-50 disabled:border-0 transition-all placeholder-shown:border-2 placeholder-shown:border-neutral-800 placeholder-shown:border-t-neutral-800 border focus:border-2 border-t-transparent focus:border-t-transparent text-sm px-3 py-2.5 rounded-[7px] border-neutral-800 focus:border-primary'
          placeholder=' '
        />
        <label className="flex w-full h-full select-none pointer-events-none absolute left-0 font-normal !overflow-visible truncate peer-placeholder-shown:text-white/40 leading-tight peer-focus:leading-tight peer-disabled:text-transparent peer-disabled:peer-placeholder-shown:text-white transition-all -top-[3px] peer-placeholder-shown:text-sm text-[11px] peer-focus:text-[11px] before:content[' '] before:block before:box-border before:w-2.5 before:h-1.5 before:mt-[4px] before:mr-1 peer-placeholder-shown:before:border-transparent before:rounded-tl-md before:border-t-2 peer-focus:before:border-t-2 before:border-l-2 peer-focus:before:border-l-2 before:pointer-events-none before:transition-all peer-disabled:before:border-transparent after:content[' '] after:block after:flex-grow after:box-border after:w-2.5 after:h-1.5 after:mt-[4.5px] after:ml-1 peer-placeholder-shown:after:border-transparent after:rounded-tr-md after:border-t-2 peer-focus:after:border-t-2 after:border-r peer-focus:after:border-r-2 after:pointer-events-none after:transition-all peer-disabled:after:border-transparent peer-placeholder-shown:leading-[3.75] text-gray-500 peer-focus:text-primary before:border-neutral-800 peer-focus:before:!border-primary after:border-neutral-800 peer-focus:after:!border-primary">
          {placeholder}
        </label>
      </div>
    </div>
  );
};

export default Input;
